export const MAX_MEDIA_RETRIES = 10;
export const MEDIA_RETRY_TIMEOUT = 2000;
